<template>
  <div class="navbar-routes-group" v-if="filteredRoutesLinks.length">
    <el-dropdown
      :class="[`r-dropdown`, { active }]"
      size="mini"
      :show-timeout="100"
      placement="bottom-start"
      v-if="filteredRoutesLinks.length > 1"
      trigger="click"
    >
      <div class="navbar-routes-group__title">
        <r-icon :name="mainIcon" :size="24" />
        <r-text v-if="active && active.key">{{ $t(active.key) }}</r-text>
        <r-text v-else>{{ $t($route.name) }}</r-text>
        <r-icon name="drop-down" :size="24" class="navbar-dropdown-arrow" />
      </div>
      <el-dropdown-menu slot="dropdown" class="r-dropdown-menu navbar-dropdown">
        <r-title type="subtitle-2" class="navbar-routes-group__list-title">{{
          $t(routesGroup.value)
        }}</r-title>
        <el-dropdown-item
          v-for="link in filteredRoutesLinks"
          :key="link.id"
          :class="{ active: isActive(link) }"
        >
          <div
            class="r-dropdown-menu__item-wrapper"
            @click="setDefaultPath(link)"
          >
            <div class="navbar-routes-group__item">
              <r-icon :name="link.icon" :size="24" />
              <r-text v-if="link.key">{{ $t(link.key) }}</r-text>
              <r-text v-else>{{ $t(link.value) }}</r-text>
            </div>
          </div>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <router-link :to="filteredRoutesLinks[0].to" v-else>
      <div
        :class="[
          'navbar-routes-group__item single',
          { active: isActive(filteredRoutesLinks[0]) }
        ]"
        @click="setDefaultPath(filteredRoutesLinks[0])"
      >
        <r-icon :name="routesGroup.icon" :size="24" />
        <r-text v-if="filteredRoutesLinks[0].key">{{
          $t(filteredRoutesLinks[0].key)
        }}</r-text>
        <r-text v-else>{{ $t(filteredRoutesLinks[0].value) }}</r-text>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    routesGroup: {
      type: Object,
      required: true
    }
  },
  computed: {
    mainIcon() {
      return this.active ? this.active.icon : this.routesGroup.icon;
    },
    filteredRoutesLinks() {
      return this.routesGroup.routesLinks.filter(
        e =>
          this.hasModule(e.name) ||
          e.value === "situation-centre" ||
          e.value === "event-editor" ||
          e.value === "calculations"
      );
    },
    active() {
      return this.filteredRoutesLinks.find(e => this.isActive(e));
    }
  },
  methods: {
    hasModule(name) {
      return this.$store.getters.hasModule(name);
    },
    isActive(link) {
      return this.$route.path.indexOf(link.to) > -1;
    },
    setDefaultPath(link) {
      this.$router.push(link.to);
      this.$store.commit("SET_DEFAULT_PATH", link.to);
      this.$store.dispatch("SAVE_MAIN_USER_CONFIG");
    }
  }
};
</script>

<style lang="scss">
.navbar-routes-group {
  height: 100%;
  display: flex;
  align-items: center;
  .r-dropdown {
    height: 32px;
    display: flex;
    align-items: center;
    border-radius: var(--border-radius);
    box-sizing: border-box;
    overflow: hidden;
    transition: all 0.15s ease;
    &:hover {
      background-color: var(--accent_selected) !important;
      svg {
        fill: var(--accent_primary) !important;
      }
    }
    &.active {
      background-color: var(--accent_selected) !important;
      .r-icon {
        width: auto;
        svg {
          fill: var(--accent_primary) !important;
        }
      }
      .navbar-routes-group {
        &__title {
          box-sizing: border-box;
          padding: 6px;
          .r-text {
            padding: 0 6px;
            width: auto;
            opacity: 1;
            color: var(--accent_primary) !important;
            svg {
              color: var(--accent_primary) !important;
            }
          }
        }
      }
    }
  }
  &__title {
    display: flex;
    align-items: center;
    padding: 6px 4px;
    .r-text {
      width: 0;
      opacity: 0;
      transition: all 0.15s ease;
      box-sizing: border-box;
      color: var(--accent_primary) !important;
    }
    .navbar-dropdown-arrow {
      margin-left: -4px;
    }
  }
  &__item {
    &.single {
      display: flex;
      height: 32px;
      align-items: center;
      box-sizing: border-box;
      padding: 6px 8px;
      border-radius: 32px;
      .r-text {
        padding: 0 6px 0 8px;
        width: auto;
        opacity: 1;
        white-space: nowrap;
      }
      &.active {
        background-color: var(--accent_selected) !important;
        .r-icon {
          svg {
            fill: var(--accent_primary) !important;
          }
        }
        .navbar-routes-group {
          &__title {
            .r-text {
              color: var(--accent_primary) !important;
            }
          }
        }
      }
    }
  }
}
.navbar-dropdown {
  top: 47px !important;
  .el-dropdown-menu__item {
    box-sizing: border-box;
    .navbar-routes-group__item {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .r-icon {
        margin-right: 8px;
        width: auto;
      }
    }
    a {
      width: 100%;
    }
    &.active {
      background-color: var(--accent_selected) !important;
      a {
        cursor: initial !important;
      }
    }
  }
}
.navbar-routes-group__list-title {
  padding: 5px 8px 8px;
  &:before {
    content: none !important;
  }
}
</style>

<i18n>
{
  "ru": {
    "gis": "Цифровой КСОДД",
    "mtp": "Моделирование транспортных потоков",
    "map": "Карта",
    "charts": "Графики",
    "book": "Справочник",
    "situation-center": "Ситуационный центр",
    "event-editor": "Редактор событий",
    "c-models": "Расчеты и сценарии (новое)",
    "modelling": "Моделирование",
    "traffic-counts": "Замеры интенсивности",
    "traffic-count": "Замеры интенсивности",
    "public-transport": "Реестр ОТ",
    "calculations": "Расчеты и сценарии (новое)",
    "scenario-modelling": "Расчеты и сценарии",

    "moscow": "СЦ - Москва (демо-данные)",
    "chelyabinsk": "СЦ - Челябинск"
  },
  "en": {
    "gis": "Digital CSODD",
    "mtp": "Traffic modeling",
    "map": "Map",
    "charts": "Charts",
    "book": "Book",
    "situation-center": "Situation Centre",
    "event-editor": "Event editor",
    "c-models": "Calculations and scenarios (new)",
    "modelling": "Modelling",
    "traffic-counts": "Traffic Counts",
    "traffic-count": "Traffic Counts",
    "public-transport": "PT Registry",
    "calculations": "Calculations and scenarios (new)",
    "scenario-modelling": "Calculations and scenarios",

    "moscow": "SC - Moscow (demo-data)",
    "chelyabinsk": "SC - Chelyabinsk"
  }
}
</i18n>
